/* eslint-disable operator-linebreak */

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    this.header = document.getElementById("shopify-section-header");
    this.icon = this.querySelector("[data-predictive-search-icon]");
    this.input = this.querySelector(`[data-predictive-search-input${windowWidth < 1024 ? '-mobile' : ''}]`);
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search-results]"
    );
    this.isOpen = false;
    this.wrapper = document.querySelector(".header__menu-item--search");

    this.closeIcon = this.querySelector(".predictive-search__icon-wrapper.close-icon");

    this.closeIcon.addEventListener("click", () => {
      this.close();
    });

    this.icon.addEventListener("click", () => {
      this.toggle();
    
      const inputElements = document.querySelectorAll(".predictive-search__input");
    
     // Check if there is at least one element with the class (2 elements present, one for mobile and another for desktop)
  if (inputElements.length >= 1) {
    // Check the window width

    // Focus on the appropriate element based on the window width
    if (windowWidth < 1024) {
      // Focus on the first element (index 0)
      inputElements[0].focus();
    } else {
      // Focus on the second element (index 1)
      inputElements[1].focus();
    }
  }
    }, false);

    window.addEventListener("click", (event) => this.outsideClick(event));

    if (this.input) {
      this.input.addEventListener(
        "input",
        this.debounce(() => this.onChange(), 300).bind(this)
      );
    }
  }

  disconnectedCallback() {
    this.icon.removeEventListener("click", () => this.toggle());
    window.removeEventListener("click", (event) => this.outsideClick(event));

    this.input.removeEventListener(
      "input",
      this.debounce(() => this.onChange(), 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm) {
      // console.log('no term')
      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    const url = `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search-results`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        const error = new Error(response.statusText);
        this.close();
        throw error;
      }

      const text = await response.text();

      const resultsMarkup = new DOMParser().parseFromString(text, "text/html");
      const searchResultsHtml = resultsMarkup.getElementById(
        "shopify-section-predictive-search-results"
      );

      if (searchResultsHtml) {
        this.predictiveSearchResults.innerHTML = searchResultsHtml.innerHTML;
      }

      this.open();
    } catch (error) {
      this.close();
      throw error;
    }
  }

  resetSearch() {
    const elToRemove = this.predictiveSearchResults.querySelector(
      ".predictive-search-results"
    );

    if (elToRemove) {
      elToRemove.remove();
    }
  }

  open() {
    this.header.classList.add("search-open");
    this.isOpen = true;
  }

  close() {
    this.header.classList.remove("search-open");
    this.resetSearch();
    this.isOpen = false;
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  outsideClick(event) {
    if (this.header && this.wrapper) {
      if (
        this.header.contains(event.target) &&
        this.header.classList.contains("search-open")
      ) {
        this.header.classList.add("search-open");
      } else {
        this.header.classList.remove("search-open");
      }
    }
  }

  debounce(fn, wait) {
    let timer;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
